// Components
import { StepMediaImageCompleteComponent } from './step-media-image-complete.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_MEDIA_IMAGE_COMPLETE = {
  stepIdentifier: 'mediaUploadFlowStepImageComplete',
  identifier: 'uploadImageComplete',
  component: StepMediaImageCompleteComponent,
  name: 'Review',
  title: 'Your verified content is ready',
  subtitle: 'Download your signed copy and publish your image.',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
} as MediaUploadFlowStep;

// The same review step for a PDF or audio file, which is published to ODDR only
export const STEP_MEDIA_FILE_COMPLETE = {
  ...STEP_MEDIA_IMAGE_COMPLETE,
  subtitle: 'Download your signed copy and share your ODDR link.',
} as MediaUploadFlowStep;
